export const SMILE_CART_BASE_URL =
  "https://smile-cart-backend-staging.neetodeployapp.com/";
